export const sindicationRefs = {
  PARTNER: 'Partner',
  PARTNER_REPRESENTANT: 'PartnerRepresentant',
};
